import modalCalendarGridComponent from './modalCalendarGrid.component';
import modalCalendarGridService from  './modalCalendarGrid.Service';

let modalCalendarGridModule = angular.module('vacations-absences.modalCalendarGrid', [])

  .component('modalCalendarGrid', modalCalendarGridComponent)
  .service('modalCalendarGridService', modalCalendarGridService)
  .name;

export default modalCalendarGridModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalCalendarGrid/modalCalendarGrid.js